/**
 * Textos (`ca`) del tall «selfchecks» de Qualitat i APPCC. Tall propi: no es toca `ca.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const selfChecksCa = {
  'backoffice.selfChecks': {
    subtitle:
      'Els controls que fa l’equip cada dia, setmana o mes (neteja, temperatures, plagues…): què s’ha de comprovar i què s’ha registrat.',
    tabsLabel: 'Seccions dels autocontrols',
    tabRecords: 'Registres',
    tabMissed: 'Registres no fets',
    tabTemplates: 'Plantilles',
    loadError: 'No s’han pogut carregar les dades. Torna-ho a provar.',
    loading: 'Carregant…',

    // Enums
    kind_cleaning: 'Neteja i desinfecció',
    kind_temperature: 'Temperatures',
    kind_pests: 'Control de plagues',
    kind_custom: 'Altres',
    frequency_daily: 'Diària',
    frequency_weekly: 'Setmanal',
    frequency_monthly: 'Mensual',
    fieldType_ok_ko: 'OK / KO',
    fieldType_number: 'Número',
    fieldType_text: 'Text',
    fieldType_photo: 'Foto',
    result_ok: 'OK',
    result_ko: 'KO',

    // Períodes
    periodWeek: 'Setmana {{week}} · {{from}} – {{to}}',

    // Registres
    filterTemplate: 'Plantilla',
    filterTemplateAll: 'Totes les plantilles',
    filterResult: 'Resultat',
    filterResultAll: 'Tots',
    filterFrom: 'Des del dia',
    filterTo: 'Fins al dia',
    recordsEmpty: 'Encara no hi ha cap registre d’autocontrol.',
    recordsEmptyFiltered: 'Cap registre coincideix amb els filtres.',
    recordsTruncated:
      'Es mostren els {{limit}} registres més recents. Afina els filtres per veure’n d’altres.',
    recordPeriod: 'Període',
    recordDoneBy: 'Fet per {{name}} · {{when}}',
    unknownPerson: 'Persona desconeguda',
    templateInactive: '{{name}} (baixa)',
    templateUnknown: '(plantilla no disponible)',
    notesLabel: 'Observacions',
    fieldUnavailable: '(camp retirat)',
    valueOutOfRange: 'Fora de rang',
    valueNoAnswer: 'Sense resposta',
    valueRange: 'rang {{min}} – {{max}}',
    valueRangeMin: 'mínim {{min}}',
    valueRangeMax: 'màxim {{max}}',
    photoView: 'Veure la foto',
    photoOpening: 'Obrint…',
    photoError: 'No s’ha pogut obrir la foto.',
    ncLabel: 'No conformitat',
    ncLinksError: 'No s’han pogut carregar els enllaços a les no conformitats.',

    // Registres no fets
    missedIntro:
      'Períodes en què tocava fer un autocontrol i no n’hi ha cap registre. Cada plantilla compta des del dia que es va crear i fins que es va donar de baixa. El període en curs no hi surt fins que acaba.',
    missedRangeHint: 'Com a molt un any; l’últim dia és ahir.',
    missedEmpty: 'No hi ha cap període sense fer en aquest interval. Tot al dia.',
    missedEmptyNoTemplates:
      'Encara no hi ha cap plantilla. Crea les de base a la pestanya Plantilles.',
    missedCount_one: '{{count}} període sense fer',
    missedCount_other: '{{count}} períodes sense fer',
    missedColTemplate: 'Plantilla',
    missedColFrequency: 'Freqüència',
    missedColPeriod: 'Període',
    missedColDue: 'Venciment',
    dueTitle: 'Toca ara',
    dueHint: 'Plantilles que encara no tenen cap registre al seu període en curs.',
    dueEmpty: 'Tots els autocontrols d’ara estan fets.',
    duePending: 'Pendent',

    // Plantilles
    templatesTitle: 'Plantilles d’autocontrol',
    templatesSubtitle:
      'Què s’ha de comprovar, cada quan i on. Una plantilla donada de baixa deixa de tocar, però els registres que ja té es conserven.',
    colName: 'Nom',
    colKind: 'Tipus',
    colFrequency: 'Freqüència',
    colZone: 'Zona',
    colEquipment: 'Equip',
    colFields: 'Camps',
    newTemplate: 'Nova plantilla',
    editTemplate: 'Edita la plantilla',
    searchLabel: 'Cerca per nom, tipus o zona',
    filterKindAll: 'Tots els tipus',
    filterFrequencyAll: 'Totes les freqüències',
    emptyTemplates:
      'Encara no hi ha cap plantilla. Pots crear les tres de base (neteja i desinfecció, temperatures i plagues) i adaptar-les.',
    seedAction: 'Crea les plantilles de base',
    seeding: 'Creant…',
    seedCreated_one: 'S’ha creat {{count}} plantilla de base.',
    seedCreated_other: 'S’han creat {{count}} plantilles de base.',
    seedNone: 'Les plantilles de base ja hi eren: no s’ha creat res.',
    seedError: 'No s’han pogut crear les plantilles de base.',
    deactivateTitle: 'Dona de baixa la plantilla',
    deactivateBody:
      'La plantilla deixarà de tocar a l’App i de comptar als registres no fets. Els registres que ja té es conserven. Cal un motiu.',
    actionError: 'No s’ha pogut completar l’acció. Torna-ho a provar.',

    // Diàleg de plantilla
    sectionTemplate: 'Plantilla',
    sectionFields: 'Camps a comprovar',
    sectionFieldsHint:
      'Cada camp és una cosa que l’operari ha de contestar. Un KO o un número fora de rang obre una no conformitat.',
    fieldName: 'Nom',
    fieldKind: 'Tipus d’autocontrol',
    fieldFrequency: 'Freqüència',
    fieldFrequencyHint: 'Cada període (un dia, una setmana o un mes) es pot fer un sol cop.',
    fieldFrequencyLocked:
      'Aquesta plantilla ja té registres: la freqüència no es pot canviar. Dona-la de baixa i crea’n una de nova.',
    fieldZone: 'Zona',
    fieldZoneNone: 'Sense zona',
    fieldEquipment: 'Equip',
    fieldEquipmentNone: 'Sense equip',
    optionUnavailable: '(no disponible)',
    fieldSortOrder: 'Ordre',
    fieldSortOrderHint: 'Les plantilles es mostren per aquest ordre.',
    fieldInstructions: 'Instruccions',
    fieldInstructionsHint: 'L’operari les veu abans de fer l’autocontrol.',
    fieldsEmpty: 'Encara no hi ha cap camp. Afegeix-ne un per començar.',
    addField: 'Afegeix un camp',
    fieldLabel: 'Què es comprova',
    fieldTypeLabel: 'Tipus de resposta',
    fieldTypeLocked: 'El tipus no es pot canviar un cop creat el camp.',
    fieldRequired: 'Obligatori',
    fieldMin: 'Mínim',
    fieldMax: 'Màxim',
    fieldUnit: 'Unitat',
    fieldRangeHint: 'Fora d’aquest rang el valor és KO.',
    fieldPosition: 'Camp {{n}}',
    moveUp: 'Puja',
    moveDown: 'Baixa',
    removeField: 'Treu',
    errorName: 'Escriu el nom de la plantilla.',
    errorFieldLabel: 'Cada camp necessita un nom.',
    errorRange: 'El mínim no pot ser més gran que el màxim.',
    errorDuplicateName: 'Ja hi ha una plantilla vigent amb aquest nom.',
    saveError: 'No s’ha pogut desar la plantilla. Torna-ho a provar.',
  },
} as const;
